import routes from "../constants/routes";
import { lazyLoadRoutes } from "../utils/lazy-loader";

export const masterRoutes = [
  {
    path: routes.company.companyInfo,
    element: lazyLoadRoutes("company/index"),
  },
  {
    path: routes.master.country,
    element: lazyLoadRoutes("masters/country/pages/country"),
  },
  {
    path: routes.master.state,
    element: lazyLoadRoutes("masters/state/pages/state"),
  },
  {
    path: routes.master.currency,
    element: lazyLoadRoutes("masters/currency/pages/currency"),
  },
  {
    path: routes.master.gender,
    element: lazyLoadRoutes("masters/gender/pages/gender"),
  },
  {
    path: routes.master.qualification,
    element: lazyLoadRoutes("masters/qualification/pages/qualification"),
  },
  {
    path: routes.master.project,
    element: lazyLoadRoutes("masters/project/pages/project"),
  },
  {
    path: routes.master.grade,
    element: lazyLoadRoutes("masters/grade/pages/grade"),
  },
  {
    path: routes.master.division,
    element: lazyLoadRoutes("masters/division/pages/division"),
  },
  {
    path: routes.master.designation,
    element: lazyLoadRoutes("masters/designation/pages/designation"),
  },
  {
    path: routes.master.department,
    element: lazyLoadRoutes("masters/department/pages/department"),
  },
  {
    path: routes.master.category,
    element: lazyLoadRoutes("masters/category/pages/category"),
  },
  {
    path: routes.master.branch,
    element: lazyLoadRoutes("masters/branch/branch"),
  },
  {
    path: routes.master.branchAdd,
    element: lazyLoadRoutes("masters/branch/branchAdd"),
  },
  {
    path: `${routes.master.branchAdd}/:id`,
    element: lazyLoadRoutes("masters/branch/branchAdd"),
  },
  {
    path: routes.master.bank,
    element: lazyLoadRoutes("masters/bank/pages/bank"),
  },
  {
    path: routes.master.prefixName,
    element: lazyLoadRoutes("masters/prefix-name/prefix-name"),
  },
  {
    path: routes.master.payrollCycle,
    element: lazyLoadRoutes("masters/payroll-cycle/payroll-cycle"),
  },
  {
    path: routes.master.idProof,
    element: lazyLoadRoutes("masters/id-proof/id-proof"),
  },
  {
    path: routes.master.documentType,
    element: lazyLoadRoutes("masters/document-type/pages/document-type"),
  },
  {
    path: routes.master.costCenter,
    element: lazyLoadRoutes("masters/cost-center/pages/cost-center"),
  },
  {
    path: routes.master.skills,
    element: lazyLoadRoutes("masters/skills/pages/skills"),
  },
  {
    path: routes.master.location,
    element: lazyLoadRoutes("masters/location/location"),
  },
  {
    path: routes.master.locationAdd,
    element: lazyLoadRoutes("masters/location/locationAdd"),
  },
  {
    path: `${routes.master.locationAdd}/:id`,
    element: lazyLoadRoutes("masters/location/locationAdd"),
  },
  {
    path: routes.master.bonus,
    element: lazyLoadRoutes("masters/bonus/pages/bonus"),
  },
  {
    path: routes.master.bonusCategory,
    element: lazyLoadRoutes("masters/bonus-category/pages/bonusCategory"),
  },
  {
    path: routes.master.bonusStatutory,
    element: lazyLoadRoutes("masters/bonus-statutory/pages/bonusStatutory"),
  },
  {
    path: routes.master.essentials,
    element: lazyLoadRoutes("masters/essentials/pages/essentials"),
  },
  {
    path: routes.master.source,
    element: lazyLoadRoutes("masters/attandance/pages/source"),
  },
  {
    path: routes.master.cron,
    element: lazyLoadRoutes("masters/cron/pages/cron"),
  },
  {
    path: routes.master.empCodeCategory,
    element: lazyLoadRoutes(
      "masters/emp-code-category/pages/emp-code-category"
    ),
  },
];
